var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"content",style:({ backgroundImage: `url(${_vm.backgroundImage})` })},[_c('div',{staticClass:"formContent EC_width1"},[_c('div',{staticClass:"flex1 display_center_ud"}),_c('router-view',{on:{"change-background":_vm.updateBackgroundImage}})],1),_c('footer_login')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }